<div class="mla">
    <div class="mla-alert" *ngIf="canAttest">
        <app-alert-info subjectMessage=" " uniqueID="labsattestation" contentMessage="Select at least five (5) essential labs to mark as reviewed during this measurement period."></app-alert-info>
    </div>
    <div class="mla-alert" *ngIf="!canAttest">
        <app-alert-danger subjectMessage=" " uniqueID="labsattestation1" contentMessage="Cannot submit for selected measurement period."></app-alert-danger>
    </div>    
    <div class="mla-meaurementperiod">
        <div class="mla-meaurementperiod-label">
            Measurement Period
        </div>
        <div class="mla-meaurementperiod-text">
            <p-dropdown [options]="measurementperiodlist" optionLabel="name" [(ngModel)]="selectedmeasurementperiod" (onChange)="onMPChange($event)"/>
        </div>        
        <div class="mla-meaurementperiod-score" *ngIf="memberLabAttestation">
            Completion Score : {{memberLabAttestation.scoreValue}} of 6
        </div>                
    </div>
    <div class="mla-details-label">
        <div class="mla-details-label-left">
            Essential Labs
        </div>
        <div class="mla-details-label-right">
            {{selectedlab ? selectedlab.name : ''}}
        </div>        
    </div>
    <div class="mla-details">
        <div class="mla-details-left">
            <p-listbox 
                [options]="labs" 
                [(ngModel)]="selectedlab" 
                optionLabel="name" 
                [style]="{ width: '100%' }"
                [listStyle]="{'max-height': '385px'}">
                    <ng-template let-listitem pTemplate="item">
                        <div class="flex align-items-center gap-2" *ngIf="labState(listitem) == 1">
                            <img src="./assets/images/circle-arrow-right-solid.png" style="width: 18px" />
                            <span>&nbsp;{{ listitem.name }}</span>
                        </div>
                        <div class="flex align-items-center gap-2" *ngIf="labState(listitem) == 2">
                            <img src="./assets/images/circle-exclamation-solid.png" style="width: 18px" />
                            <span>&nbsp;{{ listitem.name }}</span>
                        </div>                        
                        <div class="flex align-items-center gap-2" *ngIf="labState(listitem) == 3">
                            <img src="./assets/images/circle-check-solid.png" style="width: 18px" />
                            <span>&nbsp;{{ listitem.name }}</span>
                        </div>                                                
                    </ng-template>
            </p-listbox>                
        </div>        
        <div class="mla-details-right" *ngIf="memberLabAttestation && selectedlab && selectedlab.code === 'CBC'">
            <div class="mla-details-right-date">
                <div class="mla-details-right-date-label-labdate">
                    Date of Labs
                </div>
                <div class="mla-details-right-date-text-labdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtlabdatecbc" id="txtlabdateidcbc" [ngModel]="memberLabAttestation.cbC_DateOfLabs | date:'yyyy-MM-dd'" [value]="memberLabAttestation.cbC_DateOfLabs | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.cbC_DateOfLabs = $event; onChange($event)" #cbclabdate="ngModel">
                </div>
                <div class="mla-details-right-date-label-reviewdate">
                    Date of Review
                </div>    
                <div class="mla-details-right-date-text-reviewdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtreviewdatecbc" id="txtreviewdateidcbc" [ngModel]="memberLabAttestation.cbC_DateOfReview | date:'yyyy-MM-dd'" [value]="memberLabAttestation.cbC_DateOfReview | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.cbC_DateOfReview = $event; onChange($event)" #cbcreviewdate="ngModel">
                </div>    
            </div>
            <div class="mla-details-right-details">
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        WBC
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="cbC_WBC_name" id="cbC_WBC" [(ngModel)]="memberLabAttestation.cbC_WBC" (change)="oninputchange()">
                    </div>                                
                </div>
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        Hgb
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="cbC_Hgb_name" id="cbC_Hgb" [(ngModel)]="memberLabAttestation.cbC_Hgb" (change)="oninputchange()">
                    </div>                                
                </div>                            
            </div>
        </div>
        <div class="mla-details-right" *ngIf="memberLabAttestation && selectedlab && selectedlab.code === 'BMP'">
            <div class="mla-details-right-date">
                <div class="mla-details-right-date-label-labdate">
                    Date of Labs
                </div>
                <div class="mla-details-right-date-text-labdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtlabdatebmp" id="txtlabdateidbmp" [ngModel]="memberLabAttestation.bmP_DateOfLabs | date:'yyyy-MM-dd'" [value]="memberLabAttestation.bmP_DateOfLabs | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.bmP_DateOfLabs = $event; onChange($event)" #bmplabdate="ngModel">
                </div>
                <div class="mla-details-right-date-label-reviewdate">
                    Date of Review
                </div>    
                <div class="mla-details-right-date-text-reviewdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtreviewdatebmp" id="txtreviewdateidbmp" [ngModel]="memberLabAttestation.bmP_DateOfReview | date:'yyyy-MM-dd'" [value]="memberLabAttestation.bmP_DateOfReview | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.bmP_DateOfReview = $event; onChange($event)" #bmpreviewdate="ngModel">
                </div>    
            </div>            
            <div class="mla-details-right-details">
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        NA
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="bmP_Na_name" id="bmP_Na" [(ngModel)]="memberLabAttestation.bmP_Na" (change)="oninputchange()">
                    </div>                                
                </div>
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        K_Hgb
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="bmP_K_Hgb_name" id="bmP_K_Hgb" [(ngModel)]="memberLabAttestation.bmP_K_Hgb" (change)="oninputchange()">
                    </div>                                
                </div>                            
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        Scr
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="bmP_Scr_name" id="bmP_Scr" [(ngModel)]="memberLabAttestation.bmP_Scr" (change)="oninputchange()">
                    </div>                                
                </div>                            
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        BUN
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="bmP_BUN_name" id="bmP_BUN" [(ngModel)]="memberLabAttestation.bmP_BUN" (change)="oninputchange()">
                    </div>                                
                </div>                            
            </div>          
        </div>
        <div class="mla-details-right" *ngIf="memberLabAttestation && selectedlab && selectedlab.code === 'LFT'">
            <div class="mla-details-right-date">
                <div class="mla-details-right-date-label-labdate">
                    Date of Labs
                </div>
                <div class="mla-details-right-date-text-labdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtlabdatelft" id="txtlabdateidlft" [ngModel]="memberLabAttestation.lfT_DateOfLabs | date:'yyyy-MM-dd'" [value]="memberLabAttestation.lfT_DateOfLabs | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.lfT_DateOfLabs = $event; onChange($event)" #lftlabdate="ngModel">
                </div>
                <div class="mla-details-right-date-label-reviewdate">
                    Date of Review
                </div>    
                <div class="mla-details-right-date-text-reviewdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtreviewdatelft" id="txtreviewdateidlft" [ngModel]="memberLabAttestation.lfT_DateOfReview | date:'yyyy-MM-dd'" [value]="memberLabAttestation.lfT_DateOfReview | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.lfT_DateOfReview = $event; onChange($event)" #lftreviewdate="ngModel">
                </div>    
            </div>            
            <div class="mla-details-right-details">
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        AST
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="lfT_AST_name" id="lfT_AST" [(ngModel)]="memberLabAttestation.lfT_AST" (change)="oninputchange()">
                    </div>                                
                </div>
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        ALT
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="lfT_ALT_name" id="lfT_ALT" [(ngModel)]="memberLabAttestation.lfT_ALT" (change)="oninputchange()">
                    </div>                                
                </div>                            
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        AlKphos
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="lfT_AlKphos_name" id="lfT_AlKphos" [(ngModel)]="memberLabAttestation.lfT_AlKphos" (change)="oninputchange()">
                    </div>                                
                </div>                                            
            </div>     
        </div>
        <div class="mla-details-right" *ngIf="memberLabAttestation && selectedlab && selectedlab.code === 'TSH'">
            <div class="mla-details-right-date">
                <div class="mla-details-right-date-label-labdate">
                    Date of Labs
                </div>
                <div class="mla-details-right-date-text-labdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtlabdatetsh" id="txtlabdateidtsh" [ngModel]="memberLabAttestation.tsH_DateOfLabs | date:'yyyy-MM-dd'" [value]="memberLabAttestation.tsH_DateOfLabs | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.tsH_DateOfLabs = $event; onChange($event)" #tshlabdate="ngModel">
                </div>
                <div class="mla-details-right-date-label-reviewdate">
                    Date of Review
                </div>    
                <div class="mla-details-right-date-text-reviewdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtreviewdatetsh" id="txtreviewdateidtsh" [ngModel]="memberLabAttestation.tsH_DateOfReview | date:'yyyy-MM-dd'" [value]="memberLabAttestation.tsH_DateOfReview | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.tsH_DateOfReview = $event; onChange($event)" #tshreviewdate="ngModel">
                </div>    
            </div>
        </div>        
        <div class="mla-details-right" *ngIf="memberLabAttestation && selectedlab && selectedlab.code === 'HGB'">
            <div class="mla-details-right-date">
                <div class="mla-details-right-date-label-labdate">
                    Date of Labs
                </div>
                <div class="mla-details-right-date-text-labdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtlabdatehgb" id="txtlabdateidhgb" [ngModel]="memberLabAttestation.hgB_DateOfLabs | date:'yyyy-MM-dd'" [value]="memberLabAttestation.hgB_DateOfLabs | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.hgB_DateOfLabs = $event; onChange($event)" #hgblabdate="ngModel">
                </div>
                <div class="mla-details-right-date-label-reviewdate">
                    Date of Review
                </div>    
                <div class="mla-details-right-date-text-reviewdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtreviewdatehgb" id="txtreviewdateidhgb" [ngModel]="memberLabAttestation.hgB_DateOfReview | date:'yyyy-MM-dd'" [value]="memberLabAttestation.hgB_DateOfReview | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.hgB_DateOfReview = $event; onChange($event)" #hgbreviewdate="ngModel">
                </div>    
            </div>
        </div>             
        <div class="mla-details-right" *ngIf="memberLabAttestation && selectedlab && selectedlab.code === 'FLP'">
            <div class="mla-details-right-date">
                <div class="mla-details-right-date-label-labdate">
                    Date of Labs
                </div>
                <div class="mla-details-right-date-text-labdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtlabdateflp" id="txtlabdateidflp" [ngModel]="memberLabAttestation.fastingLipidPanel_DateOfLabs | date:'yyyy-MM-dd'" [value]="memberLabAttestation.fastingLipidPanel_DateOfLabs | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.fastingLipidPanel_DateOfLabs = $event; onChange($event)" #cbclabdate="ngModel">
                </div>
                <div class="mla-details-right-date-label-reviewdate">
                    Date of Review
                </div>    
                <div class="mla-details-right-date-text-reviewdate">
                    <input class="form-control" type="date" required="false" max="{{today | date: 'yyyy-MM-dd'}}" name="txtreviewdateflp" id="txtreviewdateidflp" [ngModel]="memberLabAttestation.fastingLipidPanel_DateOfReview | date:'yyyy-MM-dd'" [value]="memberLabAttestation.fastingLipidPanel_DateOfReview | date:'yyyy-MM-dd'"  (ngModelChange)="memberLabAttestation.fastingLipidPanel_DateOfReview = $event; onChange($event)" #cbcreviewdate="ngModel">
                </div>    
            </div>            
            <div class="mla-details-right-details">
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        Total Cholesterol
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="fastingLipidPanel_TotalCholesterol_name" id="fastingLipidPanel_TotalCholesterol" [(ngModel)]="memberLabAttestation.fastingLipidPanel_TotalCholesterol" (change)="oninputchange()">
                    </div>                                
                </div>
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        LDL
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="fastingLipidPanel_LDL_name" id="fastingLipidPanel_LDL" [(ngModel)]="memberLabAttestation.fastingLipidPanel_LDL" (change)="oninputchange()">
                    </div>                                
                </div>                            
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        HDL
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false"  name="fastingLipidPanel_HDL_name" id="fastingLipidPanel_HDL" [(ngModel)]="memberLabAttestation.fastingLipidPanel_HDL" (change)="oninputchange()">
                    </div>                                
                </div>                                            
                <div class="mla-details-right-details-row">
                    <div class="mla-details-right-details-row-label">
                        Triglycerides
                    </div>
                    <div class="mla-details-right-details-row-text">
                        <input class="form-control" type="text" required="false" name="fastingLipidPanel_Triglyceride_name" id="fastingLipidPanel_Triglyceride" [(ngModel)]="memberLabAttestation.fastingLipidPanel_Triglyceride" (change)="oninputchange()">
                    </div>                                
                </div>                  
            </div>                     
        </div>        
    </div>    
    <div class="mla-summarylabel">
        Summary and Recommendations
    </div>
    <div class="mla-summarytext" *ngIf="memberLabAttestation">
        <textarea placeholder="Enter your Summary and Recommendations" rows="3" style="width: 100%;" [(ngModel)]="memberLabAttestation.summary" (change)="oninputchange()"></textarea>
    </div>     
</div>
<app-continue-dialog key="continueDialog"></app-continue-dialog>
